import type { BalsaBackgroundConfig } from "../components/ui/gradient-background";

/** Generated by Balsa UI. Edit this configuration in your application. */
export const studioBackground: BalsaBackgroundConfig = {
  "schemaVersion": 3,
  "preset": "obsidian-fold",
  "seed": 1847,
  "colorMode": "custom",
  "colors": [
    "#050506",
    "#0E0F1A",
    "#2B2D31",
    "#74777D",
    "#D7D8DA"
  ],
  "speed": 0.185,
  "scale": 1.09,
  "warp": 1.12,
  "wave": 1.2,
  "softness": 0.7,
  "grain": 0.06,
  "grainSize": 1.15,
  "contrast": 1.18,
  "brightness": -0.08,
  "direction": 18,
  "quality": "auto",
  "fieldOctaves": 4,
  "fieldFrequency": 0.78,
  "noiseAmount": 0.05,
  "noiseOctaves": 4,
  "noiseFrequency": 1.1,
  "warpFrequency": 1.05,
  "pattern": "ribbon",
  "patternDensity": 2.35,
  "patternCenterX": 0,
  "patternCenterY": 0,
  "patternComplexity": 4,
  "effect": "dither",
  "effectScale": 10,
  "effectAngle": 0,
  "effectMix": 1,
  "effectColorMode": "gradient",
  "effectInk": "#F5F5F4",
  "effectPaper": "#0A0A0B",
  "effectInvert": false,
  "effectLevels": 4,
  "effectShape": "round",
  "effectCharacters": " .:-=+*#%@"
};
